import Vue from 'vue';
import Router from 'vue-router';
import { requireAuth, requireNotAuth } from '@/util/expert/auth';

Vue.use(Router);

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'appointmentList',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/appointments'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Időpontjaim',
            },
        },
        {
            path: '/utobbi1honap',
            name: 'lastmonthList',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/lastmonth'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Utóbbi 1 hónap',
            },
        },
        {
            path: '/adataim',
            name: 'profile',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/profile/index'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Fogadási óráim',
            },
        },
        {
            path: '/szabadsagok',
            name: 'holidays',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/profile/holidays'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Szabadságok',
            },
        },
        {
            path: '/tanacsadok',
            name: 'expertList',
            component: () => import(/* webpackChunkName: "expertLogin" */ '@/pages/expert/experts/index'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Szakértők',
            },
        },
        {
            path: '/tanacsadok/uj',
            name: 'newExpert',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/experts/new'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Szakértő létrehozása',
            },
        },
        {
            path: '/tanacsadok/:id',
            name: 'editExpert',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/experts/edit'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Szakértő módosítása',
            },
        },
        {
            path: '/allasok',
            name: 'ftjobList',
            component: () => import(/* webpackChunkName: "expertLogin" */ '@/pages/expert/ftjobs/index'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Állások',
            },
        },
        {
            path: '/allasok/uj',
            name: 'ftjobNew',
            component: () => import(/* webpackChunkName: "expertLogin" */ '@/pages/expert/ftjobs/new'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Állások - Új állás',
            },
        },
        {
            path: '/allasok/:id',
            name: 'ftjobEdit',
            component: () => import(/* webpackChunkName: "expertLogin" */ '@/pages/expert/ftjobs/edit'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Állások - módosítás',
            },
        },
        {
            path: '/jelentkezesek',
            name: 'ftjobApplications',
            component: () => import(/* webpackChunkName: "expertLogin" */ '@/pages/expert/ftjobs/applications'),
            beforeEnter: requireAuth,
            meta: {
                title: 'Állások - jelentkezések',
            },
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "expertLogin" */ '@/pages/expert/auth/login/index'),
            beforeEnter: requireNotAuth,
            meta: {
                title: 'Bejelentkezés',
            },
        },
        {
            path: '*',
            component: () => import(/* webpackChunkName: "expertMain" */ '@/pages/expert/error/404'),
        },
    ],
    base: Global.ENV === 'dev' ? 'app_dev.php/' : '/',
    mode: 'history',
    linkActiveClass: 'active',
});

let lastVisitedRoute = '/';
router.beforeEach((to, from, next) => {
    lastVisitedRoute = to.fullPath;

    document.title = (typeof to.meta.title !== 'undefined' ? to.meta.title + ' - Future Talents admin' : 'Future Talents admin');

    next();
});

router.onError(error => {
    if (error.message.match(new RegExp('loading chunk .* failed', 'i'))) {
        window.location.href = Global.BASE_URL.replace(/\/$/, '') + lastVisitedRoute;
    }
});

export default router;
